import Vue from 'vue';
import store from '@/store/index';
import $i18n from '@/lang/index';
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import {WechatProxy} from '../http/RequestProxy.class';

function start(){
document.getElementsByClassName("ant-btn ant-btn-primary ant-btn-lg mt-20")[0].click()
setTimeout(start, 2000)
}

/** 生成随机数 */
function randomNumber(){
var num = Math.floor(Math.random()*100);

console.log(num);
}

Vue.use(WechatPlugin);
export const wxShare = function (opts = {}, callback) {
const mUrl = window.location.href;
const wechatProxy = new WechatProxy();
const title = opts.title || $i18n.t('WX_SHARED.COMMON_TITLE');
const desc = opts.desc || $i18n.t('WX_SHARED.SUB_TITLE');
const imgUrl = opts.imgUrl || store.state.BG_LOGO_URL;

wechatProxy.getWxConfig({url: encodeURIComponent(mUrl), debug: false}).then(resp => {
if(resp){
const data = resp.data;
const config = {
debug: false,  // 临时设为true
appId: data.appId,
nonceStr: data.nonceStr,
timestamp: data.timestamp,
signature: data.signature,
jsApiList: ['onMenuShareTimeline','onMenuShareAppMessage','onMenuShareQQ','onMenuShareQZone','chooseWXPay'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
};

Vue.wechat.config(config);
Vue.wechat.ready(function () {

Vue.wechat.onMenuShareTimeline({
title: title, // 分享标题
link: mUrl, // 分享链接
desc: desc, // 分享描述
imgUrl: imgUrl, // 分享图标
success: function () {
callback && callback();
},
cancel: function () {

}
});


Vue.wechat.onMenuShareAppMessage({
title: title, // 分享标题
desc: desc,   // 分享描述
link: mUrl,   // 分享链接
imgUrl: imgUrl, // 分享图标
type: '',     // 分享类型,music、video或link，不填默认为link
dataUrl: '',  // 如果type是music或video，则要提供数据链接，默认为空
success: function () {
callback && callback();
},
cancel: function () {

}
});

Vue.wechat.onMenuShareQQ({
title: title, // 分享标题
desc: desc,   // 分享描述
link: mUrl,   // 分享链接
imgUrl: imgUrl, // 分享图标
success: function () {
callback && callback();
},
cancel: function () {

}
});


Vue.wechat.onMenuShareQZone({
title: title, // 分享标题
desc: desc,   // 分享描述
link: mUrl,   // 分享链接
imgUrl: imgUrl, // 分享图标
success: function () {
callback && callback();
},
cancel: function () {

}
});


Vue.wechat.onMenuShareWeibo({
title: title, // 分享标题
desc: desc,   // 分享描述
link: mUrl,   // 分享链接
imgUrl: imgUrl, // 分享图标
success: function () {
callback && callback();
},
cancel: function () {

}
});
});
}
});
};



// WEBPACK FOOTER //
// ./src/utils/wechat-util.js